import {
  ArticleFeedback,
  HelpCenterArticle,
  HelpCenterArticleBreadcrumbs,
  HelpCenterArticleCta,
  HelpCenterArticleStructuredData,
  HelpCenterMeta,
  HelpCenterNavigationContainer,
  HelpCenterPageWrapper,
} from '@aboutyou/logic-components';
import {Divider} from '@aboutyou/ui-components';
import React from 'react';

export const ArticlePage = () => {
  return (
    <HelpCenterPageWrapper>
      <HelpCenterMeta />
      <HelpCenterArticleStructuredData />
      <HelpCenterNavigationContainer light>
        <HelpCenterArticleBreadcrumbs />
        <HelpCenterArticle />
        <HelpCenterArticleCta />
        <Divider noMargin />
        <ArticleFeedback />
      </HelpCenterNavigationContainer>
    </HelpCenterPageWrapper>
  );
};
